import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { useEffect, useState } from "react"
import { InsightsPeriod } from "../../../api/insights"
import { ScreenContentWithContext } from "../../../components/ScreenContentWithContext"
import { useInsights } from "../../../contexts"
import { reduceDateByOneHour } from "../../../utils"
import { SpeedingOverTime, WorstSpeeders } from "../../components/SafetyInsightsComponents/speeding"
import { PrevPolicyDropdown } from "../../components"

export const Speeding: React.FC<RouteComponentProps> = () => {
  const { periods, insightsProviderLoading } = useInsights()
  const [activePeriod, setPeriod] = useState<InsightsPeriod | null>(null)

  const setActivePeriod = (period: InsightsPeriod) => {
    const endDate = reduceDateByOneHour(period.endedAt)
    const newPeriod = { ...period, endedAt: endDate }
    setPeriod(newPeriod)
  }

  useEffect(() => {
    if (!periods) return
    const periodsWithData = periods.periods.filter((it) => it.analytics !== null && typeof it.analytics !== `undefined`)
    setPeriod(periodsWithData[periodsWithData.length - 1])
  }, [periods])

  return (
    <>
      <DocumentTitleOverride>Flock Motor | Safety Score - Speeding</DocumentTitleOverride>
      <ScreenContentWithContext title="Speeding" PreviousPolicyDropdown={<PrevPolicyDropdown />}>
        <SpeedingOverTime
          loading={insightsProviderLoading}
          periods={periods?.periods || []}
          activePeriod={activePeriod}
          setActivePeriod={setActivePeriod}
        />
        <WorstSpeeders activePeriod={activePeriod} loading={insightsProviderLoading} />
      </ScreenContentWithContext>
    </>
  )
}
